<template>
  <SogPage>
    <SogCard style="width: 100%">
      <SogCardActions :is-toolbar="true">
        <SogCardActionButton
          mdi-icon="mdi-printer"
          tooltip="Drucken"
          @click="p_onPrint"
        />
        <SogCardActionButton
          mdi-icon="mdi-download"
          tooltip="Herunterladen"
          @click="p_onDownload"
        />
        <SogCardActionButton
          mdi-icon="mdi-magnify-minus-outline"
          tooltip="Verkleinern"
          @click="p_onZoomOut"
        />
        <SogCardActionButton
          mdi-icon="mdi-magnify-plus-outline"
          tooltip="Vergrößern"
          @click="p_onZoomIn"
        />
        <SogCardActionButton
          v-show="_account.isBranch"
          mdi-icon="mdi-cart-plus"
          tooltip="Einzeleinkauf"
          @click="p_onPurchase"
        />
        <SogCardActionButton
          mdi-icon="mdi-exit-to-app"
          tooltip="Schließen"
          @click="p_onExit"
        />
      </SogCardActions>
      <SogCardContent>
        <div
          ref="_container"
          :style="{ width: '100%', height: '90vh', overflow: 'auto', display: 'flex' }"
        >
          <VuePdfEmbed
            v-if="pdfSource"
            ref="_pdfViewer"
            :source="pdfSource"
            :width="pageWidth"
            :style="{ margin: 'auto' }"
          />
        </div>
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import {onBeforeRouteUpdate, useRoute, useRouter} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiDocument from "@/modules/Document/api";
import VuePdfEmbed from "vue-pdf-embed";
import SogPage from "@/shared/ui/SogPage.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import {useAccountStore} from "@/stores/accountStore";
import apiFile from "@/shared/services/apiFile";


interface Props {
  id?: string
}

const props = withDefaults(defineProps<Props>(), {
      id: undefined
    }
)


const _title = ref("Template")
const _spinner = useSpinner()
const _pdfViewer = ref<InstanceType<typeof VuePdfEmbed> | null>(null)
const pdfSource = ref<Uint8Array | null>(null)

const _container = ref<HTMLElement | null>(null)
const _baseWidth = ref(0)
const _zoom = ref(1)
const pageWidth = computed(() => _baseWidth.value > 0 ? Math.round(_baseWidth.value * _zoom.value) : undefined)

const _router = useRouter()
const _account = useAccountStore()

const _navigationStore = useNavigationStore();


async function p_init() {
  _spinner.show()
  try {
    _title.value = "Template"
    if (props.id)
      pdfSource.value = await apiDocument.getFileData(props.id)
  }
  finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  const route = useRoute();
  await p_init(route)
  _baseWidth.value = Math.max(0, (_container.value?.clientWidth ?? 800) - 4)
})

onBeforeRouteUpdate(async (to) => {
  await p_init(to)
});

async function p_onExit() {
  if(_account.isBranch) {
    await _navigationStore.goToShoppingCart();
  }
  else{
    await _router.push("/");
  }
}

async function p_onPurchase() {
  await _navigationStore.goToShoppingCart();
}

function p_onZoomIn() {
  _zoom.value = Math.min(_zoom.value * 1.2, 5)
}

function p_onZoomOut() {
  _zoom.value = Math.max(_zoom.value / 1.2, 0.25)
}

async function p_onPrint() {
  _pdfViewer.value?.print()
}

async function p_onDownload() {
  if(props.id)
    await apiFile.downloadFile(props.id)
}
//http://localhost:8080/pdf/view/85336a7f8e8840d89cb56edb320624e2.pdf
</script>
<style scoped>
</style>
